// Modules
import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';

// Styled Components
import * as EVENT from './event-footer.styles';
import * as TYPO from '../../styles/common/typo.styles';

// Types
import { Event } from '../../types/events';

// Assets
import Facebook from '../../assets/facebook.svg';
import Twitter from '../../assets/twitter.svg';
import Mail from '../../assets/mail-bg.svg';

// Constants
import { constant } from '../../constants/contant';

import { capitalizedLang } from '../../selectors/common.selector';
import EventCheckout from '../event-checkout/event-checkout.component';
import EventContact from '../event-contact/event-contact.component';
import AdditionalInfo from '../additional-info/additional-info.component';

const EventFooter = ({
	event,
	dir,
	language
}: {
	event: Event;
	dir: string;
	language:string
}): ReactElement => {
	const lang = useSelector((state: any) => capitalizedLang()(state));
	const url = window.location.href;

	const dataSocial = (social: any) => {
		(window as any).dataLayer.push({
			'event': 'social_share',
			'media_share_click': social,
			'page_source': url,
			'page_type': 'event',
		});
	}

	// Render
	return (
		<EVENT.Footer>
			<EVENT.AdditionalInfo>
				<AdditionalInfo event={event} dir={dir} lang={lang} />
			</EVENT.AdditionalInfo>
			<EVENT.Social>
				<TYPO.BodyBold>{constant[lang].VARIABLES.SHARE_WITH}</TYPO.BodyBold>
				<EVENT.Links>
					<EVENT.Link onClick={()=>dataSocial('facebook')} href={constant.SOCIAL_LINKS.facebook + window.location.hostname + `/${language.toLowerCase()}/event/${event.drupalInternalId}`} target={'_blank'}>
						<EVENT.SocialIcon src={Facebook}  alt="Facebook"/>
					</EVENT.Link>
					<EVENT.Link onClick={()=>dataSocial('twitter')} href={constant.SOCIAL_LINKS.twitter + window.location.hostname + `/${language.toLowerCase()}/event/${event.drupalInternalId}`} target={'_blank'}>
						<EVENT.SocialIcon src={Twitter} alt="Twitter"/>
					</EVENT.Link>

					<EVENT.Link onClick={()=>dataSocial('mail')} href={constant.SOCIAL_LINKS.mail} target={'_blank'}>
						<EVENT.SocialIcon src={Mail} alt="Email"/>
					</EVENT.Link>
				</EVENT.Links>
			</EVENT.Social>
		</EVENT.Footer>
	);
};

export default EventFooter;
